export default __webpack_public_path__ + "media/projects/yellow3-thumb-d405ad76.svg";